<template lang="pug">
v-container
  v-row
    v-col(cols="9")
      v-card
        v-card-title Соглашение № 1
        v-card-text
          v-file-input(
            v-model="files"
            multiple
          )
          fileSign(
            :files="filesReturn"
          )
</template>
<script>
import fileSign from '@/components/FileSignature/index.vue';
import FileInput from '@/components/InputFields/FileInput.vue';

export default {
  components: {
    FileInput,
    fileSign,
  },
  data() {
    return {
      files: [],
    };
  },
  computed: {
    filesReturn() {
      return this.files.map((i) => ({ is: i }));
    },
  },
};
</script>
